export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_RES = 'SIGN_IN_RES'
